import { BaseComponent } from "utils/base-component"

import "./login.scss"
import "./login-full-page.scss"
import "./static/background.jpg"
import "./static/surf-forecast_outside--header_logo.webp"

export class Login extends BaseComponent {
  static cssClass = "login"

  init() {
    this.elements("login-container").forEach((item) => {
      const passwordToggle = item.element.querySelector(
        ".js-password-toggle",
      ) as HTMLButtonElement | null
      const passwordInput = item.element.querySelector(
        'input[name="session[password]"]',
      ) as HTMLInputElement | null

      if (!passwordToggle || !passwordInput) return

      passwordToggle.addEventListener("click", () => {
        const revealed = passwordInput.type === "password"
        const nextLabel = revealed
          ? passwordToggle.dataset.labelHide || "Hide password"
          : passwordToggle.dataset.labelShow || "Show password"
        const toggleLabel = passwordToggle.querySelector(".js-password-toggle-label")

        passwordInput.type = revealed ? "text" : "password"
        passwordToggle.setAttribute("aria-label", nextLabel)
        passwordToggle.setAttribute("aria-pressed", String(revealed))
        if (toggleLabel) toggleLabel.textContent = nextLabel
        passwordToggle.querySelector(".js-eye-show")?.toggleAttribute("hidden", revealed)
        passwordToggle.querySelector(".js-eye-hide")?.toggleAttribute("hidden", !revealed)
      })
    })
  }
}
